<div class="main-view">
  <div class="back">
    <a
      (click)="goBack()"
      style="display: inline-flex; align-items: center"
    >
      <mat-icon
        style="font-size: 16px; display: inline-flex; align-items: center"
        >arrow_back</mat-icon
      >
      <span>Back</span>
    </a>
  </div>
  <div class="main-logo">
    <div class="banner-box">
      <div class="banner-content">
        <span class="welcome-text"
          >Welcome back to, {{ quarter }} Credit risk review {{ year }}
        </span>
        <h1>{{ client_name }}</h1>
        <h3>Track and manage all of your borrowers request in one place.</h3>
      </div>
    </div>
  </div>
  <div class="motif-container">
    <div class="motif-row">
      <div class="motif-col-xs-4 motif-col-sm-4 motif-col-md-4 motif-col-lg-4 my-2">
        <div style="display:flex; gap:9px; align-items:center;">
          <motif-form-field style="min-width:150px;">
            <label motifLabel class="select-label">Select Product</label>
            <motif-select
              aria-label="Select Product"
              placeholder="Select Product"
              [selectTitle]="'Select Product'"
              [(ngModel)]="selectedProductValue"
              labelPosition="inside"
              (selectionChange)="productSelected($event)"
            >
              <motif-option *ngFor="let product of products" [value]="product">{{product}}</motif-option>
            </motif-select>
          </motif-form-field>

          <motif-form-field style="min-width:160px; position: relative;">
            <input
              motifInput
              type="text"
              aria-label="Search"
              placeholder="Search Obligors"
              [(ngModel)]="searchQuery"
              (ngModelChange)="onSearchChange()"
              style="padding-right: 14px; max-width: 160px; height: 44px !important;"
            />
            <span style="position:absolute; right:8px; top:50%; transform:translateY(-50%); cursor:pointer; color:#757575;">
              <mat-icon *ngIf="searchQuery" (click)="searchQuery=''; onSearchChange()">close</mat-icon>
            </span>
          </motif-form-field>
        </div>
      </div>
      <div class="motif-col-xs-6 motif-col-sm-6 motif-col-md-6 motif-col-lg-6">
        <motif-toast
          [autoHide]="false"
          type="info"
          [show]="showToast"
          ariaLabelCloseButton="Close info toast message"
        >
          <ng-container *ngIf="toastType == 'success'">
            {{ toastMessage }}
          </ng-container>
          <ng-container *ngIf="toastType == 'error'">
            There was a problem with that action
          </ng-container>
          <ng-container *ngIf="toastType == 'info'" class="text-nowrap">
            Extraction Started.
          </ng-container>
          <ng-container *ngIf="toastType == 'warning'">
            warning message
          </ng-container>
        </motif-toast>
      </div>
      <div
        class="motif-col-xs-2 motif-col-sm-2 motif-col-md-2 motif-col-lg-2 button-box"
      >
        <div style="display:flex; gap:8px; align-items:center;">
          <button
            motif-button
            size="large"
            type="button"
            class="action-button download-csv-button"
            [disabled]="csvDownloading"
            (click)="openDownloadConfirm()"
            placement="top"
            aria-label="Download Missing Documents Report(CSV)"
            [motif-tooltip]="csvDownloading ? 'Preparing CSV...' : 'Download Missing Documents Report(CSV)'"
            style="border-radius:5px;"
          >
            <motif-icon style="height: 16px !important; width: 16px !important; color:#ffffff;" [iconFunction]="motifFileIcFileDownload24px"></motif-icon>
          </button>
          <button
            motif-button
            size="large"
            style="text-wrap: nowrap; border-radius: 5px;"
            class="action-button"
            [disabled]="
              !selectedProduct || !allAssetAvailable || extractionInProgress
            "
            (click)="runExtraction($event)"
          >
            <motif-icon [iconFunction]="iconoirDatabaseBackup"> </motif-icon> Run
            extraction
          </button>
        </div>
      </div>
    </div>
    <div class="motif-row" style="margin-bottom: 24px;">
      <div
        class="motif-col-xs-12 motif-col-sm-12 motif-col-md-12 motif-col-lg-12"
      >
       <div style="position: relative; width: 100%;
           border: 1px solid #7660ff;
           border-radius: 8px;">
        <motif-table #motifTable
          [columnDefs]="columnDefs"
          [rowData]="displayedDataSource"
          rowSelection="multiple"
          [suppressRowHoverHighlight]="true"
          [pagination]="true"
          [paginationPageSize]="pagesize"
          (cellValueChanged)="onCellValueChanged($event)"
          [gridOptions]="gridOptions"
          cellClass="truncate-cell"
          ></motif-table>
          <div style="font-family: EYInterstate; position: absolute; left: 0; bottom: 0; padding: 8px 0 8px 8px; z-index: 2; background: transparent; pointer-events: none; font-size: 14px;margin-bottom: 10px;margin-left: 14px;">
          <span *ngIf="totalCount > 0">
            Total items: {{ totalCount }}
          </span>
          <span *ngIf="totalCount === 0">
            No entries
          </span>
        </div>
      </div>
  <!-- Custom cell templates for tooltips on Facilities & ID, Borrower Name, Facility Type, Asset Class, Triggered By -->
  <ng-template #obligorNameTemplate let-row>
    <span class="truncate-cell" [motif-tooltip]="row.obligor_name" placement="top">{{ row.obligor_name }}</span>
  </ng-template>
  <ng-template #subProductTypeTemplate let-row>
    <span class="facility-pill" [ngClass]="{
      'facility-ci': row.sub_product_type === 'C&I',
      'facility-cre': row.sub_product_type === 'CRE'
    }" [motif-tooltip]="row.sub_product_type" placement="top">
      {{ row.sub_product_type }}
    </span>
  </ng-template>
  <ng-template #assetClassTemplate let-row>
    <span class="truncate-cell" [motif-tooltip]="row.asset_class" placement="top">{{ row.asset_class }}</span>
  </ng-template>
  <ng-template #createdByTemplate let-row>
    <span [motif-tooltip]="row.created_by" placement="top">{{ row.created_by }}</span>
  </ng-template>
  <ng-template #createdAtTemplate let-row>
    <span class="facility-pill" [ngClass]="{
      'facility-ci': row.sub_product_type === 'C&I',
      'facility-cre': row.sub_product_type === 'CRE'
    }" [motif-tooltip]="row.created_at ? (row.created_at | date:'dd MMM yyyy HH:mm:ss') : row.created_at" placement="top">
      {{ row.created_at ? (row.created_at | date:'dd MMM yyyy') : '' }}
    </span>
  </ng-template>
      </div>
    </div>
  </div>
</div>

<ng-template #actionsTemplate let-row="$implicit">
  <div role="group" class="angular-button-group" aria-label="button group example">
    <button
      motifButton
      type="button"
      size="large"
      class="view-action-button truncate-cell"
      [motif-tooltip]="'Run Individual Extraction'"
      (click)="runIndividualExtraction(row, $event)"
      [disabled]="!row.asset_class || row.step_status === 'IN_PROGRESS'"
      [ngClass]="{
        'disabled-action-button': (!row.asset_class || row.step_status === 'IN_PROGRESS'),
        'enabled-action-button': (row.asset_class && row.step_status !== 'IN_PROGRESS')
      }"
    >
      <motif-icon
        [iconFunction]="iconoirCustomPageLast"
      >
      </motif-icon>
    </button>
    <button
      motifButton
      type="button"
      size="large"
      class="view-action-button truncate-cell"
      (click)="viewDoc(row, $event)"
      [motif-tooltip]="'View document'"
      placement="bottom"
    >
      <motif-icon [iconFunction]="iconoirDocMagnifyingGlassIn"> </motif-icon>
    </button>
    <button
      motifButton
      type="button"
      size="large"
      class="view-action-button truncate-cell mapping-list-button"
      (click)="goToResultScreen(row, $event)"
      [motif-tooltip]="'Mapping list'"
      placement="bottom"
    >
      <motif-icon class="mapping-list-button" [iconFunction]="iconoirCustomTaskList"> </motif-icon>
    </button>
  </div>
</ng-template>

<ng-template #extractionStatusTemplate let-row="$implicit">
  <span class="status-pill"
    [ngClass]="{
      'status-completed': row.step_status?.trim().toLowerCase() === 'completed',
      'status-partial': row.step_status?.trim().toLowerCase() === 'partial_completed',
      'status-failed': row.step_status?.trim().toLowerCase() === 'failed',
      'status-cancelled': row.step_status?.trim().toLowerCase() === 'cancelled',
      'status-inprogress': row.step_status?.trim().toLowerCase() === 'in_progress',
      'status-pending': row.step_status?.trim().toLowerCase() === 'pending'
    }"
  >
    {{ getExtractionDisplayStatus(row.step_status) }}
  </span>
  <!-- uncomment this for stop extraction and progress when we integrate -->
  <div style="margin-left: 0.5rem;">
  <ng-container *ngIf="row.step_status?.trim().toLowerCase() !== 'cancelled' && row.step_status?.trim().toLowerCase() !== 'failed'">
        <div style="display:flex; align-items:center; gap:8px;">
          <button
            *ngIf="row.step_status?.trim().toLowerCase() == 'in_progress'"
            motifButton
            size="small"
            color="secondary"
            class="stop-extraction-button"
            (click)="onStopButtonClick(row, $event)"
            [motif-tooltip]="'Stop extraction'"
            aria-label="Stop extraction"
          >
            <mat-icon style="font-size:14px; line-height:14px;">stop</mat-icon>
          </button>
      <!-- <motif-progress-bar
            [showLabel]="true"
            [newProgressbar]="true"
            [circle]="false"
            [determinated]="true"
            [customLabel]="false"
            [progress]="getProgress(row)"
            [ngStyle]="{
              '--progress-bar-color':
                row.step_status?.trim().toLowerCase() === 'completed' ? 'green' :
                row.step_status?.trim().toLowerCase() === 'failed' ? 'red' :
                row.step_status?.trim().toLowerCase() === 'cancelled' ? 'yellow' :
                getProgress(row) === 0 ? 'yellow' : 'blue'
            }"
          >
            <div progressbar-label>
              {{ getProgressLabel(row) }}
            </div>
          </motif-progress-bar> -->
        </div>
      </ng-container>
  </div>
</ng-template>

<div id="myModal" class="modal" *ngIf="confirmationModal">
  <!-- Modal content -->
  <div class="modal-content">
    <div class="motif-row" style="margin-bottom: 3rem">
      <div class="motif-col-lg-12" style="text-align: center">
        <label for="dependentElement" class="asset-label">
          Confirm Asset Class Change
        </label>
        <span
          class="close"
          (click)="confirmationModal = false"
          style="margin-left: auto"
          >&times;</span
        >
      </div>
      <div
        class="motif-col-lg-12"
        style="margin-top: 3rem; display: flex; justify-content: center"
      >
        <button
          motifButton
          color="primary"
          size="medium"
          (click)="callUpdateAPI()"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</div>
<div *ngIf="showRequiredDocsModal"
  style="position:fixed; inset:0; display:flex; align-items:center; justify-content:center; z-index:2000;">
  <div style="position: absolute; inset:0; background: rgba(0,0,0,0.45);"></div>
  <div role="dialog" aria-modal="true"
    style="position:relative; background:#fff; width:420px; max-width:90%; border-radius:8px; padding:20px; box-shadow:0 10px 30px rgba(0,0,0,0.3); z-index:2001;">
    <button aria-label="Close" (click)="closeRequiredDocsModal()"
      style="position:absolute; right:8px; top:8px; border:none; background:transparent; font-size:20px; cursor:pointer;">&times;</button>
    <div style="margin-top: 0; font-size: 16px; font-weight: bold; font-family: EYInterstate; display:flex; align-items:center; gap:8px;">
      <span aria-hidden="true" style="color:#d32f2f; font-size:20px; font-weight:700; line-height:1;">!</span>
      <span>Required document category is unavailable</span>
    </div>
    <p style="margin:8px 0 12px 0; color:#444;">Please upload the missing document(s) in SharePoint before continuing
      with extraction.</p>
    <div *ngIf="requiredModalCategories && requiredModalCategories.length > 0" style="margin-bottom:12px;">
      <strong style="font-family: EYInterstate ;">Missing categories:</strong>
      <ul style="margin:6px 0 0 18px;">
        <li style="margin-bottom: 0px;" *ngFor="let c of requiredModalCategories">{{ c }}</li>
      </ul>
    </div>
    <div *ngIf="!requiredModalCategories || requiredModalCategories.length === 0" style="margin-bottom:12px;">
      No category details available.
    </div>
    <div style="display:flex; justify-content:center; gap:8px; margin-top:8px;">
      <button (click)="onRunAnywayFromRequiredModal()"
        style="padding:8px 16px; border-radius:4px; border:1px solid #d32f2f; background:#fff; color:#d32f2f; cursor:pointer;">Proceed to Run Extraction</button>
      <button (click)="closeRequiredDocsModal()"
        style="padding:8px 16px; border-radius:4px; border:none; background:#2b61ff; color:#fff; cursor:pointer;">Close</button>
    </div>
  </div>
</div>

<!-- Download confirmation modal -->
<div *ngIf="showDownloadConfirmModal"
  style="position:fixed; inset:0; display:flex; align-items:center; justify-content:center; z-index:2000;">
  <div style="position: absolute; inset:0; background: rgba(0,0,0,0.45);"></div>
  <div role="dialog" aria-modal="true"
    style="position:relative; background:#fff; width:420px; max-width:90%; border-radius:8px; padding:20px; box-shadow:0 10px 30px rgba(0,0,0,0.3); z-index:2001;">
    <button aria-label="Close" (click)="cancelDownload()"
      style="position:absolute; right:8px; top:8px; border:none; background:transparent; font-size:20px; cursor:pointer;">&times;</button>
    <div style="margin-top: 0; font-size: 16px; font-weight: bold; font-family: EYInterstate; display:flex; align-items:center; gap:8px;">
      <span>Download CSV</span>
    </div>
    <p style="margin:8px 0 12px 0; color:#444;">Download the missing document category list for all obligors.</p>
    <div style="display:flex; justify-content:end; gap:8px; margin-top:8px;">
      <button (click)="confirmDownload()" class="modal-action-btn">Confirm</button>
      <button (click)="cancelDownload()" class="modal-action-btn">Close</button>
    </div>
  </div>
</div>
